"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertBase64ToBlob = void 0;
async function convertBase64ToBlob(base64Data) {
    const base64Response = await fetch(`data:application/pdf;base64,${base64Data}`);
    const blob = await base64Response.blob();
    return blob;
}
exports.convertBase64ToBlob = convertBase64ToBlob;
//# sourceMappingURL=convertBase64ToBlob.js.map